export default __webpack_public_path__ + "static/media/Swap-Button.50c19415.svg";